import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import AccountSetting from './components';
const AccountSetting = lazy (() => import(/* webpackChunkName: "AccountSetting" */'./components'));
const routes = () => (
  <PrivateRoute
    exact
    path='/settings/account-setting'
    component={AccountSetting}
  />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/AccountSetting/routes.js